import React from 'react';

const BTWhatsappConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false
				},
				toolbar: {
					display: false
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	},
	routes: [
		{
			path: '/btw',
			component: React.lazy(() => import('./BTWhatsapp'))
		}
	]
};

export default BTWhatsappConfig;
